/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

import styles from '../../../status2/styles';

const SearchBox = styled.div`
  width: 12rem;
  position: relative;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const SearchBoxSVG = styled.svg`
  left: 0.75rem;
  width: 1rem;
  height: 1rem;
  position: absolute;
  top: 50%;
  margin-top: -0.5rem;
  line-height: 1;
  fill: #9faab5;
`;

const SearchBoxInput = styled.input`
  background-color: white;
  color: ${styles.colors.biscay};
  border: 1px solid ${styles.colors.avatar};
  border-radius: 0.25rem;
  width: 100%;
  transition: border 0.1s linear, background-color 0.1s linear;
  display: inline-block;
  padding: 0 2rem;
  line-height: 1.875rem;
  min-height: calc(1.875rem + (1px * 2));
`;


class QuickFind extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string
  }

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  /**
   * Debounce onChange Event. Only fires after 500ms of no activity,
   * so callback function is not repeated called as the user is typing
   *
   * @param  {Object} event React Synthentic Event
   */
  onChange(event) {
    // persist event so it is available when the timeout expires
    // is not returned to react's event pool
    event.persist();

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.props.onChange(event);
    }, 500);
  }

  render() {
    return (
      <SearchBox className={this.props.className}>
        <SearchBoxSVG>
          <use xlinkHref='/assets/icons/utility-sprite/svg/symbols.svg#search'></use>
        </SearchBoxSVG>
        <SearchBoxInput
          onFocus={ this.props.onFocus }
          type='text' id='text-input-id-1'
          placeholder={this.props.placeholder|| 'Quick Find'} onChange={this.onChange}/>
      </SearchBox>
    );
  }
}

export default QuickFind;
